<div class="hw-box-content">
    <div class="hw-header-wrap">
        <div class="row">
            <div class="col-6">
                <i class="fn-global-site"></i>
                Mail Team
            </div>
            <div class="col-6 text-right">
                <fn-button *ngIf="!showData" [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'Add'"
                    (click)="openActionMdl()"></fn-button>
            </div>
        </div>
    </div>
    <div class="hw-title">
        <div class="row">
            <div class="col-12">
                Add or update actions
            </div>
        </div>
    </div>
    <div class="hw-content">
        <div class="row">
            <div class="col-12" *ngIf="!showData">
                @if (uiMap.isDataLoaded) {
                <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='mailTeamArray'
                   [pageSize]="15" (updateRow)="updateRowAction($event)" (deleteRow)="deleteRowAction($event)"></fn-table>
                }
            </div>
        </div>
    </div>
</div>
